import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../hooks/useSiteSettings';

function Footer() {
  const { get } = useSiteSettings();
  const email = get('footer_email', 'info@kovaranalytics.com');
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-left">
        {get('footer_text', 'Copyright © 2026 Kovar Analytics. All rights reserved.')}
      </div>
      <div className="footer-links" data-testid="footer-links">
        <Link to="/refund-policy">Refund Policy</Link>
        <span>·</span>
        <Link to="/gdpr">GDPR &amp; Privacy</Link>
      </div>
      <div className="footer-right">
        <a href={`mailto:${email}`}>{email}</a>
      </div>
    </footer>
  );
}

export default Footer;
